/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogStorageUploaderListRequest = {
    sortField?: ZerogStorageUploaderListRequest.sortField;
    sortDirection?: ZerogStorageUploaderListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace ZerogStorageUploaderListRequest {

    export enum sortField {
        UPLOAD_COUNT = 'UPLOAD_COUNT',
        UPLOAD_SIZE = 'UPLOAD_SIZE',
        LAST_UPLOAD_TIME = 'LAST_UPLOAD_TIME',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

